import { render, staticRenderFns } from "./G2Widget.vue?vue&type=template&id=78fe1a6a&scoped=true&"
import script from "./G2Widget.vue?vue&type=script&lang=js&"
export * from "./G2Widget.vue?vue&type=script&lang=js&"
import style0 from "./G2Widget.vue?vue&type=style&index=0&id=78fe1a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe1a6a",
  null
  
)

export default component.exports